// extracted by mini-css-extract-plugin
export var active = "_1d-9";
export var backButton = "_1d-8";
export var clone = "_1d-e";
export var collapseBar = "_1d-k";
export var collapseMode = "_1d-m";
export var collapsed = "_1d-o";
export var dimmed = "_1d-i";
export var dragHandle = "_1d-c";
export var dropdownIcon = "_1d-g";
export var expanding = "_1d-n";
export var hidden = "_1d-x";
export var iconContainer = "_1d-q";
export var iconSwapper = "_1d-w";
export var navItem = "_1d-6";
export var navItemIcon = "_1d-f";
export var navProfile = "_1d-7";
export var notificationCountBadge = "_1d-j";
export var notificationDot = "_1d-r";
export var optionsContainer = "_1d-h";
export var primaryNav = "_1d-0";
export var primaryNavDivider = "_1d-v";
export var primaryNavResizeHandle = "_1d-2";
export var primaryNavResizing = "_1d-1";
export var primaryNavTabSection = "_1d-u";
export var primaryTab = "_1d-p";
export var primaryTabIconBox = "_1d-s";
export var secondaryNav = "_1d-3";
export var selected = "_1d-t";
export var settingsNav = "_1d-4";
export var settingsNavItems = "_1d-5";
export var show = "_1d-d";
export var sideNav = "_1d-l";
export var teamItem = "_1d-a";
export var userProfileItem = "_1d-b";